<template>
  <div class="card-list">
    <div class="select-list" v-if="props.selectShowKey.length">
      <a-tag v-for="i in selectList" class="mb-4" :key="i[props.rowKey]" closable @close="close(i)">
        {{ i[props.selectShowKey] }}
      </a-tag>
    </div>
    <a-input-search
      v-if="props.searchKey.length"
      v-model:value="search[props.searchKey]"
      :placeholder="props.placeholder"
      @search="onSearch"
      @change="inputChange"
      class="mb-10"
    />
    <slot name="header"></slot>
    <div
      class="group-list"
      ref="scrollContainer"
      :style="{
        height: props.scrollHeight
      }"
    >
      <div class="card-list" v-show="dataList.length > 0">
        <div class="checkbox-item mt-2 mb-2" v-for="i in dataList" :key="i.value">
          <a-checkbox
            :checked="selectData.includes(i[props.rowKey])"
            @change="selectChange(i[props.rowKey], i)"
            style="width: 100%"
            :value="i[props.rowKey]"
          >
            <div class="flex-s">
              <slot name="item" :record="i"></slot>
            </div>
          </a-checkbox>
        </div>
        <div class="pt-6 pb-6 flex" v-show="loading">
          <a-spin size="small" />
        </div>
      </div>
      <div class="flex" v-show="dataList.length == 0">
        <a-empty :image="simpleImage" />
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  Checkbox as ACheckbox,
  Input as AInput,
  Empty as AEmpty,
  Tag as ATag,
  Spin as ASpin
} from 'ant-design-vue'
import { reactive, ref, onMounted, watch } from 'vue'
import httpRequest from '@/service/request/indexBase'
import { throttle } from 'lodash'
import { aigcStore } from '@/store/aigcStore'

const AInputSearch = AInput.Search
const simpleImage = AEmpty.PRESENTED_IMAGE_SIMPLE

const props = defineProps({
  value: {
    type: Array,
    default: () => []
  },
  searchData: {
    type: Object,
    default: () => ({})
  },
  placeholder: {
    type: String,
    default: '请输入搜索内容'
  },
  url: {
    type: String,
    required: true,
    default: ''
  },
  searchKey: {
    type: String,
    default: ''
  },
  searchType: {
    type: String,
    default: 'request'
  },
  selectShowKey: {
    type: String,
    default: ''
  },
  method: {
    type: String,
    default: 'get'
  },
  scrollHeight: {
    type: String || Object,
    default: null
  },
  rowKey: {
    type: String,
    default: 'id'
  }
})

const store = aigcStore()
const emits = defineEmits(['update:value'])
const selectData = ref([])
const selectList = ref([])
const dataList = ref([])
const totalList = ref([])
const loading = ref(false)
const scrollContainer = ref(null)
const total = ref(0)
const search = reactive({
  current: 1,
  size: 12,
  [props.searchKey]: ''
})

const onSearch = () => {
  if (props.searchType === 'request') {
    getList()
  } else {
    filterList()
  }
}
const selectChange = (key, i) => {
  const index = selectData.value.findIndex((i) => i === key)
  if (index > -1) {
    selectData.value.splice(index, 1)
    selectList.value.splice(index, 1)
  } else {
    selectList.value.push(i)
    selectData.value.push(key)
  }
  emits(
    'update:value',
    selectList.value.map((i) => {
      return {
        ...i,
        permissionCode: i.permissionCode ? i.permissionCode : store.permissionList[0]?.value
      }
    })
  )
}
const inputChange = () => {
  if (!search[props.searchKey].length) {
    if (props.searchType === 'request') {
      getList()
    } else {
      filterList()
    }
  }
}
const filterList = () => {
  if (search[props.searchKey].length) {
    dataList.value = totalList.value.filter(
      (i) => i[props.searchKey].indexOf(search[props.searchKey]) > -1
    )
    console.log(dataList.value, totalList.value, search[props.searchKey])
  } else {
    dataList.value = totalList.value
  }
}
const getList = (type, searchValue = {}) => {
  if (!type) {
    search.current = 1
    search.size = 12
    scrollContainer.value.scrollTop = 0
  }
  let params = {
    current: search.current,
    size: search.size,
    ...props.searchData,
    ...searchValue
  }
  if (props.searchKey.length) {
    params[props.searchKey] = search[props.searchKey]
  }
  if (props.classification) {
    params.queryType = search.queryType
    params.typeCode = search.typeCode
  }
  loading.value = true
  httpRequest[props.method]({
    url: props.url,
    params: props.method == 'get' ? params : {},
    data: props.method == 'post' ? params : {}
  }).then((res) => {
    if (res.data) {
      const list = res.data.records ? res.data.records : res.data
      totalList.value = list
      if (!type) {
        dataList.value = list
      } else {
        dataList.value.push(...list)
      }
      total.value = res.data.total
      loading.value = false
    }
  })
}
const close = (i) => {
  selectChange(i[props.rowKey], i)
}
const handleScroll = (event) => {
  const { scrollTop, clientHeight, scrollHeight } = event.target
  if (
    scrollTop + clientHeight >= scrollHeight - 20 &&
    !loading.value &&
    dataList.value.length < total.value
  ) {
    // 预留20px的提前量
    console.log('滚动到底部')
    search.current++
    getList('add')
  }
}
const throttledHandleScroll = throttle(handleScroll, 500)

onMounted(() => {
  scrollContainer.value.addEventListener('scroll', throttledHandleScroll)
  getList()
})
defineExpose({ getList })

watch(
  () => props.value,
  (value) => {
    selectList.value = value
    selectData.value = value.map((i) => i[props.rowKey])
  },
  {
    deep: true,
    immediate: true
  }
)
</script>

<style lang="less" scoped>
.card-list {
  width: 100%;
  max-width: 300px;
}
.select-list {
  max-height: 70px;
  overflow-y: auto;
}
.group {
  width: 100%;
  margin-bottom: 10px;
}
.group-list {
  max-height: 400px;
  overflow-y: auto;
}
.checkbox-item {
  width: 100%;
}

:deep(.ant-checkbox + span) {
  flex: 1;
  overflow: hidden;
}
:deep(.ant-checkbox-wrapper) {
  align-items: center;
}
</style>
